/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/controls.css';

export const MuteVideoButton = ({
  isVideoEnabled,
  canVideoStateBeChanged,
  changeVideoEnabledState
}) => (
  <i
    id="muteVideo"
    title={isVideoEnabled ? 'Mute' : 'Unmute'}
    onClick={() => changeVideoEnabledState(!isVideoEnabled)}
    className={`${!isVideoEnabled ? styles.isVisible : ''} ${
      isVideoEnabled ? styles.videoOn : styles.videoOff
    } ${canVideoStateBeChanged ? '' : styles.disabled}`}
  />
);

MuteVideoButton.propTypes = {
  isVideoEnabled: PropTypes.bool.isRequired,
  canVideoStateBeChanged: PropTypes.bool.isRequired,

  changeVideoEnabledState: PropTypes.func.isRequired
};

export default MuteVideoButton;